import React,{useState, useEffect} from 'react'
import { useNavigate } from 'react-router-dom';
import adminBg from '../../../assets/images/loginBG.png';
import { checkEmptyObj } from '../../../services/checkEmptyObj';
import './AdvertiserLogin.css';
import { adminLogin } from '../../../services/adminLogin';
import { useDispatch } from 'react-redux'
import { save } from '../../../features/token/tokenSaver';
import { advertiserLogin } from '../../../services/advertiserLogin';
import { persistRoleSession } from '../../../services/authSession';
import { prepareLoginPage } from '../../../services/prepareLoginPage';
import posthog from '../../../services/posthog';
export default function AdvertiserLogin() {
    const [phoneNumber, setPhoneNumber] = useState();
    const [advertiserLoginData, setadvertiserLoginData] = useState({ username: "", password: "" });
    const [error, setError] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch()

    useEffect(() => {
        prepareLoginPage();
    }, []);

    function onChange(propertyName, newValue) {
        setadvertiserLoginData({ ...advertiserLoginData, [propertyName]: newValue });
    }
    function onSubmit(event) {
        event.preventDefault();
        var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;


        if (checkEmptyObj(advertiserLoginData) && !advertiserLoginData.username.match(validRegex)) {
            setError(true);
            return;
        }
        else {
            advertiserLogin(advertiserLoginData).then(result => {
                if (result.status != 200) {
                    setError(true)
                    return;
                }
                setError(false);
                const fullName = result.data.fname + ' ' + result.data.lname;
                posthog.identify(advertiserLoginData.username, {
                    email: advertiserLoginData.username,
                    name: fullName,
                    role: 'advertiser',
                });
                posthog.capture('advertiser logged in', { email: advertiserLoginData.username });
                dispatch(save(result.data.token));
                persistRoleSession({
                    role: 'advertiser',
                    token: result.data.token,
                    refreshToken: result.data.refreshToken,
                    name: fullName
                });
                sessionStorage.removeItem("homeActive");
                sessionStorage.removeItem("advertisersActive");
                sessionStorage.removeItem("screensActive");
                if (result.data.requiresActivation) {
                    window.location.href = "/advertiserActivate";
                } else {
                    window.location.href = "/advertiserDashboard/home";
                }

                return;
                }).catch(e => {
                    setError(true)
                })

        }
    }
  return (
      <div className='adminLoginContainer'>
          <div className='loginContainer'>
              <form onSubmit={onSubmit}>
                  <div className='loginSubContainer'> 
                      <span className='adminLoginTitle'>Advertiser Login</span>
                      <span className='adminLoginDescription'>Login with your email and password</span>
                      <div className='adminLoginInputs'>
                          <input 
                              type="email" 
                              value={advertiserLoginData.username} 
                              onChange={(e) => { onChange("username", e.target.value) }} 
                              required 
                              placeholder='Email' 
                              className='adminLoginPhoneInput' 
                          />
                          <input 
                              type="password" 
                              required 
                              value={advertiserLoginData.password} 
                              onChange={(e) => { onChange("password", e.target.value) }} 
                              placeholder='Password' 
                              className='adminLoginPhoneInput' 
                          />
                          {error && <span className='errorPhoneVerification'>Invalid email or password</span>}
                          <div className='adminLoginUnderItemsContainer'>
                              <input type="submit" value="Login" className='adminLoginBtn' />
                              <span className='adminLoginUnderText' onClick={()=>{navigate('/advertiserSignup')}}>Want to advertise? <u>Create account</u></span>
                          </div>
                      </div>
                  </div>
              </form>
          </div>
          <div className='loginInfoPanel'>
              <img className='loginInfoBg' src={adminBg} alt='Advertiser experience visual' />
              <div className='loginInfoOverlay'>
                  <span className='loginInfoEyebrow'>Advertiser Experience</span>
                  <h2 className='loginInfoTitle'>Launch campaigns in minutes with full slot visibility</h2>
                  <p className='loginInfoDescription'>Manage creatives, track campaign status, and secure subscription placement from one dashboard.</p>
                  <ul className='loginInfoList'>
                      <li>Pick available slots in real time</li>
                      <li>Upload horizontal and vertical assets</li>
                      <li>Monitor approvals and campaign performance</li>
                  </ul>
              </div>
          </div>
    </div>
  )
}
